// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zF7Wc","left":"styles_left__3jCOX"};